import { useQuery } from '@tanstack/react-query';
import { apiGet } from '../../lib/api';
import { Button } from '../../components/Button';
import { IconButton } from '../../components/IconButton';
import { ProductImagesManager } from './ProductImagesManager';

// Standalone "Images" dialog opened from the products table. The actual image
// grid + upload lives in ProductImagesManager, which is also embedded in the
// product edit modal so both surfaces behave identically.
export function ProductImagesModal({
  productId,
  onClose,
}: {
  productId: string;
  onClose: () => void;
}): JSX.Element {
  const product = useQuery({
    queryKey: ['product', productId],
    queryFn: () => apiGet<{ name: string }>(`/products/${productId}`),
  });

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-ink/40">
      <div className="bg-surface rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="px-6 py-4 border-b border-rule flex items-center justify-between">
          <div>
            <h3 className="text-base font-semibold text-ink">Images</h3>
            <p className="text-xs text-ink-3 mt-0.5">{product.data?.name ?? '…'}</p>
          </div>
          <IconButton onClick={onClose} aria-label="Close">
            ×
          </IconButton>
        </div>
        <div className="px-6 py-4">
          <ProductImagesManager productId={productId} />
        </div>
        <div className="px-6 py-3 border-t border-rule flex justify-end">
          <Button variant="secondary" onClick={onClose}>
            Done
          </Button>
        </div>
      </div>
    </div>
  );
}
